// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.faq-container, .contact-container {
  float: left;
  display: block;
  width: 43%;
  margin-top: 40px;
}
@media (max-width: 1024px) {
  .faq-container, .contact-container {
    width: 100%;
    padding: 0 30px;
    margin-top: 30px;
  }
}

.faq-container {
  margin-right: 75px;
  margin-left: 7%;
}
@media (max-width: 1024px) {
  .faq-container {
    margin-left: 0;
  }
}

.btn {
  padding: 0 19px 0 18px;
}

.contact-img-section {
  display: block;
  float: left;
  margin-right: 20px;
  width: 17%;
}
.contact-img-section .icon-custm-style {
  color: #333333 !important;
  font-size: 84px;
}
.contact-img-section .faq-icon {
  width: 74px;
  height: 74px;
  float: right;
}
.contact-img-section .contact-icon {
  width: 74px;
  height: 83px;
  float: right;
}
@media (max-width: 1024px) {
  .contact-img-section {
    width: 30%;
  }
}

.info-section {
  float: left;
  margin-bottom: 40px;
  width: 79%;
}
.info-section .limit {
  margin-bottom: 20px;
  margin-top: 0;
}
.info-section h2 {
  font-size: 30px;
  margin-top: 0;
}
.info-section p {
  font-size: 16px;
}
@media (max-width: 1024px) {
  .info-section {
    width: 60%;
  }
}

.chat-section {
  margin-bottom: 30px;
  margin-top: 0px;
}

@media (max-width: 1024px) {
  .tab-banner-caption {
    display: none;
  }
  .info-section {
    margin-bottom: 0;
  }
  .icon-custm-style {
    font-size: 80px;
  }
  .chat-section {
    margin-bottom: 10px;
  }
  .section-seperator {
    margin: 10px 0 30px;
  }
}
.btn-secondary { /* For Safari 5.1 to 6.0 */ /* For Opera 11.1 to 12.0 */ /* For Firefox 3.6 to 15 */
  background: linear-gradient(to bottom, #087ac2 0%, hsl(204.9, 94.4%, 35.1%) 50%, hsl(204.9, 94.4%, 35.1%) 100%);
}

h1 {
  font-size: 38px;
  padding-bottom: 20px;
  font: 3.8rem/38px "Omnes-ATT-W02-Light";
  color: #191919;
  margin-bottom: 20px;
  margin-top: 20px;
}
@media (max-width: 1024px) {
  h1 {
    font: 38px/38px "Omnes-ATT-W02-Light";
    color: #191919;
    margin-bottom: 20px;
    margin-top: 20px;
  }
  h1 body {
    font-size: 16px !important;
  }
  h1 .subhead {
    padding-bottom: 20px;
    color: #191919;
    size: 14px;
  }
}

.tab-banner-caption {
  font-size: 18px;
  font-family: "ATT Aleck Sans";
  font-weight: Regular;
}

h2 {
  margin-bottom: 30px;
  margin-top: 30px;
}

.row-text {
  height: 200px;
}

.subhead {
  padding-bottom: 20px;
  color: #191919;
  size: 16px;
}

.link {
  color: hsl(204.9, 94.4%, 35.1%);
}

.icon-custm-style {
  color: #333333;
  font-size: 76px;
  padding-top: 20px;
  padding-bottom: 0px;
}

@media (max-width: 1024px) {
  .row1 {
    padding-bottom: 40px;
  }
  .supportLink {
    margin-right: 0px !important;
  }
}
p {
  margin-top: 20px;
  margin-bottom: 0px;
}

body {
  padding-bottom: 20px;
  color: #191919;
  size: 16px;
}

.tab-support-section {
  margin: 30px 0;
  position: relative;
}
@media (max-width: 1024px) {
  .tab-support-section {
    height: auto !important;
    margin: 0;
  }
}

@media (max-width: 1024px) {
  .tab-banner-section {
    position: unset !important;
  }
}
.tab-banner-section {
  overflow: hidden;
  position: relative;
}
.tab-banner-section figure {
  text-align: center;
}
.tab-banner-section figure img {
  max-width: none !important;
  height: 400px !important;
}
@media (max-width: 1024px) {
  .tab-banner-section figure img {
    width: 100%;
    margin-top: 50px;
  }
}
.tab-banner-section::after {
  clear: both;
  content: "";
  display: block;
}

.heading {
  line-height: 0px;
  padding-left: 0px !important;
}

.subheading {
  padding-bottom: 10px;
}

.tab-banner-caption {
  padding-bottom: 0px;
  padding-left: 10px;
  position: absolute;
  margin-left: 75px;
  top: 10%;
  width: 100%;
}

.btn-eligibility {
  display: inline;
}
@media (max-width: 1024px) {
  .btn-eligibility {
    display: block;
    padding: 0 25px 10px;
    text-align: center;
  }
}

.learn-more {
  display: inline;
}
@media (max-width: 1024px) {
  .learn-more {
    display: block;
    padding: 0 25px 10px;
    text-align: center;
  }
}

.msg-content {
  background-color: hsl(150, 100%, 24%);
  color: #fff;
  padding: 20px;
}

.tab-support-header {
  padding-bottom: 20px;
  padding-top: 10px;
}

.modal-footer .button-group::after {
  clear: both;
  content: "";
  display: block;
}

.container-box {
  padding-left: 70px;
}

@media (max-width: 1024px) {
  .container-box {
    padding: 0;
  }
  .icon-custm-style {
    color: #333333;
    font-size: 80px;
    padding-top: 25px;
    padding-bottom: 0px;
  }
  .btn {
    width: 100%;
    padding: 0 19px 0 18px;
  }
  .contact-sm-top {
    padding-top: 5%;
  }
  .heading {
    margin-bottom: 0;
  }
}
.tab-content-support {
  left: 0;
  padding: 0 20px;
  padding-bottom: 20px;
  /* position: absolute; */
  top: 70px;
  width: 100%;
}
.tab-content-support ul {
  margin: 12px 0 10px 20px;
}
.tab-content-support ul li {
  line-height: 20px;
  margin-top: 12px;
  padding-left: 15px;
  position: relative;
  text-align: left;
}
.tab-content-support ul li::after {
  background-color: #333333;
  border: 2px solid #333333;
  border-radius: 100%;
  content: "";
  display: block;
  height: 1px;
  left: 0;
  position: absolute;
  top: 8px;
  width: 1px;
}

.icon-play {
  width: 30px;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/pages/support/support.component.scss","webpack://./src/assets/style/var-config.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAhJA;EAEE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAiJF;AFjII;EErBJ;IAQI,WAAA;IACA,eAAA;IACA,gBAAA;EAkJF;AACF;;AA/IA;EACE,kBAAA;EACA,eAAA;AAkJF;AF7II;EEPJ;IAKI,cAAA;EAmJF;AACF;;AAhJA;EACE,sBAAA;AAmJF;;AAhJA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAmJF;AAjJE;EACE,yBAAA;EACA,eAAA;AAmJJ;AAhJE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAkJJ;AA/IE;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAiJJ;AF3KI;EEMJ;IAwBI,UAAA;EAiJF;AACF;;AA5IA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;AA+IF;AA7IE;EACE,mBAAA;EACA,aAAA;AA+IJ;AA5IE;EACE,eAAA;EACA,aAAA;AA8IJ;AA5IE;EACE,eAAA;AA8IJ;AFjMI;EEoCJ;IAmBI,UAAA;EA8IF;AACF;;AA1IA;EACE,mBAAA;EACA,eAAA;AA6IF;;AF3MI;EEmEF;IACE,aAAA;EA4IF;EAzIA;IACE,gBAAA;EA2IF;EAxIA;IACE,eAAA;EA0IF;EAvIA;IACE,mBAAA;EAyIF;EAtIA;IACE,mBAAA;EAwIF;AACF;AAnIA,iBACE,0BAAA,EACA,2BAAA,EACA,0BAAA;EACA,+GAAA;AAqIF;;AArHA;EACE,eAAA;EACA,oBAAA;EAeA,uCAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA0GF;AF5OI;EE8GJ;IAOI,qCAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;EA2HF;EAjIE;IACE,0BAAA;EAmIJ;EA7HE;IACE,oBAAA;IACA,cAAA;IACA,UAAA;EA+HJ;AACF;;AAvHA;EACE,eAAA;EACA,6BAAA;EACA,oBAAA;AA0HF;;AAvHA;EACE,mBAAA;EACA,gBAAA;AA0HF;;AAxHA;EACE,aAAA;AA2HF;;AAzHA;EACE,oBAAA;EACA,cAAA;EACA,UAAA;AA4HF;;AAzHA;EACE,+BCtKkB;ADkSpB;;AAzHA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA4HF;;AF5RI;EEoKF;IACE,oBAAA;EA4HF;EA1HA;IACE,4BAAA;EA4HF;AACF;AA1HA;EACE,gBAAA;EACA,kBAAA;AA4HF;;AA1HA;EACE,oBAAA;EACA,cAAA;EACA,UAAA;AA6HF;;AA3HA;EAKE,cAAA;EACA,kBAAA;AA0HF;AFpTI;EEoLJ;IAEI,uBAAA;IACA,SAAA;EAkIF;AACF;;AF1TI;EE8LF;IACA,0BAAA;EAgIA;AACF;AA7HA;EACE,gBAAA;EACA,kBAAA;AA+HF;AA9HE;EACE,kBAAA;AAgIJ;AA9HI;EACE,0BAAA;EACA,wBAAA;AAgIN;AF3UI;EE8MA;IAEI,WAAA;IACA,gBAAA;EA+HN;AACF;AA3HE;EACE,WAAA;EACA,WAAA;EACA,cAAA;AA6HJ;;AAzHA;EACE,gBAAA;EACA,4BAAA;AA4HF;;AAzHA;EACE,oBAAA;AA4HF;;AAzHA;EAEI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;AA2HJ;;AAvHA;EAME,eAAA;AAqHF;AF5WI;EEiPJ;IAEI,cAAA;IACA,oBAAA;IACA,kBAAA;EA6HF;AACF;;AAzHA;EAME,eAAA;AAuHF;AFvXI;EE0PJ;IAEI,cAAA;IACA,oBAAA;IACA,kBAAA;EA+HF;AACF;;AA3HA;EACE,qCC7QY;ED8QZ,WAAA;EACA,aAAA;AA8HF;;AA3HA;EACE,oBAAA;EACA,iBAAA;AA8HF;;AAzHI;EACE,WAAA;EACA,WAAA;EACA,cAAA;AA4HN;;AAxHA;EACE,kBAAA;AA2HF;;AFnZI;EE2RF;IACE,UAAA;EA4HF;EAzHF;IACE,cAAA;IACA,eAAA;IACA,iBAAA;IACA,mBAAA;EA2HA;EAxHF;IACE,WAAA;IACA,sBAAA;EA0HA;EAvHF;IACE,eAAA;EAyHA;EAtHF;IACE,gBAAA;EAwHA;AACF;AArHA;EACQ,OAAA;EACA,eAAA;EACA,oBAAA;EAEA,wBAAA;EACA,SAAA;EACA,WAAA;AAsHR;AApHQ;EACI,wBAAA;AAsHZ;AApHY;EACI,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAsHhB;AAnHY;EACI,yBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;AAqHhB;;AAjHI;EACE,WAAA;EACA,YAAA;AAoHN","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import './../../../../ng2-sapmp/src/assets/style/mixinfunction';\n\n\n.faq-container, .contact-container {\n\n  float: left;\n  display: block;\n  width: 43%;\n  margin-top: 40px;\n\n  @include respond-to (small) {\n    width: 100%;\n    padding: 0 30px;\n    margin-top: 30px;\n  }\n}\n\n.faq-container {\n  margin-right: 75px;\n  margin-left: 7%;\n\n  @include respond-to (small) {\n    margin-left: 0;\n  }\n}\n\n.btn {\n  padding: 0 19px 0 18px;\n}\n\n.contact-img-section {\n  display: block;\n  float: left;\n  margin-right: 20px;\n  width: 17%;\n\n  .icon-custm-style {\n    color: color(inverse, dark) !important;\n    font-size: 84px;\n  }\n\n  .faq-icon {\n    width: 74px;\n    height: 74px;\n    float: right;\n  }\n\n  .contact-icon {\n    width: 74px;\n    height: 83px;\n    float: right;\n  }\n      \n  @include respond-to (small) {\n    width: 30%;\n  }\n\n\n}\n\n.info-section {\n  float: left;\n  margin-bottom: 40px;\n  width: 79%;\n\n  .limit {\n    margin-bottom: 20px;\n    margin-top: 0;\n  }\n\n  h2 {\n    font-size: 30px;\n    margin-top: 0;\n  }\n  p {\n    font-size: 16px;\n  }\n\n  @include respond-to (small) {\n    width: 60%;\n  }\n\n}\n\n.chat-section {\n  margin-bottom: 30px;\n  margin-top: 0px;\n}\n\n@include respond-to (small) {\n\n  .tab-banner-caption {\n    display: none;\n  }\n\n  .info-section {\n    margin-bottom: 0;\n  }\n\n  .icon-custm-style {\n    font-size: 80px;\n  }\n\n  .chat-section{\n    margin-bottom: 10px;\n  }\n\n  .section-seperator {\n    margin: 10px 0 30px;\n  }\n\n}\n\n\n.btn-secondary {\n  background: -webkit-linear-gradient(to bottom, #087ac2 0%, color(secondary, base) 50%, color(secondary, base) 100%); /* For Safari 5.1 to 6.0 */\n  background: -o-linear-gradient(to bottom, #087ac2 0%, color(secondary, base) 50%, color(secondary, base) 100%); /* For Opera 11.1 to 12.0 */\n  background: -moz-linear-gradient(to bottom, #087ac2 0%, color(secondary, base) 50%, color(secondary, base) 100%); /* For Firefox 3.6 to 15 */\n  background: linear-gradient(to bottom, #087ac2 0%, color(secondary, base) 50%, color(secondary, base) 100%);\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\nh1 {\n  font-size: 38px;\n  padding-bottom: 20px;\n  @include respond-to(small){\n    body{\n      font-size:16px !important;\n    }\n    font: 38px/38px 'Omnes-ATT-W02-Light';\n    color:#191919;\n    margin-bottom: 20px;\n    margin-top: 20px;\n    .subhead{\n      padding-bottom: 20px;\n      color: #191919;\n      size: 14px;\n    }\n  }\n  font: 3.8rem/38px 'Omnes-ATT-W02-Light';\n  color:#191919;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.tab-banner-caption {\n  font-size: 18px;\n  font-family : 'ATT Aleck Sans';\n  font-weight: Regular;\n}\n\nh2 {\n  margin-bottom: 30px;\n  margin-top: 30px;\n}\n.row-text{\n  height:200px;\n}\n.subhead{\n  padding-bottom: 20px;\n  color: #191919;\n  size: 16px;\n}\n\n.link {\n  color: $secondary;\n}\n\n.icon-custm-style {\n  color: color(inverse, dark);\n  font-size: 76px;\n  padding-top: 20px;\n  padding-bottom:0px\n}\n\n@include respond-to(small){\n  .row1{\n    padding-bottom: 40px;\n  }\n  .supportLink {\n    margin-right: 0px !important;\n  }\n}\np{\n  margin-top: 20px;\n  margin-bottom: 0px;\n}\nbody{\n  padding-bottom: 20px;\n  color: #191919;\n  size: 16px;\n}\n.tab-support-section {\n  @include respond-to(small) {\n    height: auto !important;\n    margin: 0;\n  }\n  margin: 30px 0;\n  position: relative;\n}\n\n@include respond-to(small) {\n  .tab-banner-section{\n  position: unset !important;\n  // padding-top: 50px;\n}\n}\n.tab-banner-section {\n  overflow: hidden;\n  position: relative;\n  figure {\n    text-align: center;\n    \n    img{\n      max-width: none !important;\n      height : 400px !important;\n    }\n\n    img {\n      @include respond-to(small) {\n        width: 100%;\n        margin-top: 50px;\n      }\n    }\n  }\n  \n  &::after {\n    clear: both;\n    content: '';\n    display: block;\n  }\n}\n\n.heading {\n  line-height: 0px;\n  padding-left: 0px !important;\n}\n\n.subheading {\n  padding-bottom: 10px;\n}\n\n.tab-banner-caption {\n   //padding-top: 2px;\n    padding-bottom: 0px;\n    padding-left: 10px;\n    position: absolute;\n    margin-left: 75px;\n    top: 10%;\n    width: 100%;\n    \n}\n\n.btn-eligibility {\n  @include respond-to(small) {\n    display: block;\n    padding: 0 25px 10px;\n    text-align: center;\n  }\n  display: inline;\n}\n\n.learn-more {\n  @include respond-to(small) {\n    display: block;\n    padding: 0 25px 10px;\n    text-align: center;\n  }\n  display: inline;\n}\n\n.msg-content {\n  background-color: $success;\n  color: #fff;\n  padding: 20px;\n}\n\n.tab-support-header {\n  padding-bottom: 20px;\n  padding-top: 10px;\n}\n\n.modal-footer {\n  .button-group {\n    &::after {\n      clear: both;\n      content: '';\n      display: block;\n    }\n  }\n}\n.container-box {\n  padding-left: 70px;\n}\n@include respond-to(small) {\n  .container-box {\n    padding: 0;\n  }\n\n.icon-custm-style {\n  color: color(inverse, dark);\n  font-size: 80px;\n  padding-top: 25px;\n  padding-bottom:0px\n}\n\n.btn {\n  width:100%;\n  padding: 0 19px 0 18px;\n}\n\n.contact-sm-top {\n  padding-top: 5%;\n}\n\n.heading {\n  margin-bottom:0;\n}\n}\n\n.tab-content-support{\n        left: 0;\n        padding:0 20px;\n        padding-bottom: 20px;\n\n        /* position: absolute; */\n        top: 70px;\n        width: 100%;\n\n        ul{\n            margin: 12px 0 10px 20px;\n\n            li {\n                line-height: 20px;\n                margin-top: 12px;\n                padding-left: 15px;\n                position: relative;\n                text-align: left;\n            }\n\n            li::after{\n                background-color: #333333;\n                border: 2px solid #333333;\n                border-radius: 100%;\n                content: '';\n                display: block;\n                height: 1px;\n                left: 0;\n                position: absolute;\n                top: 8px;\n                width: 1px;\n            }\n        }\n    }\n    .icon-play{\n      width: 30px;\n      height:30px;\n    }","@import 'global-vars';\n\n$att-dark-blue: hsl(204.9,94.4%,35.1%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n@if $env == 'marketplace' {\n    $att-dark-blue: hsl(204.9,94.4%,35.1%); // #0568ae\n    $f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n    $fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n    $att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n    $f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n    // $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n    $att-orange: #ea7400; //ATT Orange\n}@else if $env == 'firstnet' {\n    $att-dark-blue:  hsl(205, 94%, 35%); // #0568ae\n    $f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n    $fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n    $att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n    $f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n    // $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n    $att-orange: #ea7400; //ATT Orange\n}\n\n\n// set color map easy use variables\n$primary: $att-orange ;\n$secondary: $att-dark-blue ;\n$default: $fb-gray ;\n$inverse: $att-dark-gray ;\n$danger: $f-red ;\n$success: $f-green ;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
